import {
	createBrowserRouter,
	Navigate,
	Route,
	RouterProvider,
	Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.scss";
import "./global.scss";
import BillMeLogo from "./assets/logo-white-BILLME.png";

// pages
import Login from "./pages/login/login.page";
import ResetPassword from "./pages/login/reset-password.page";
import Verification from "./pages/login/verification.page";
import Dashboard from "./pages/dashboard/dasboard.page";
import CreateInvoice from "./pages/create-invoice/create-invoice.page";
import InvoiceBill from "./pages/invoice-bill/invoice-bill.page";
import ActivityMonitor from "./pages/activity-monitor/activity-monitor.page";
import CustomerList from "./pages/customer-list/customer-list.page";
import EmployeeList from "./pages/employee-list/employee-list.page";
import CompanySetting from "./pages/company-setting/company-setting.page";
import ErrorPage from "./pages/error/error.page";
import MissingRoute from "./pages/error/missing.page";
// import TestPage from "./pages/test/test.page";
// import InvoiceTemplatePage from "./pages/invoice-template/invoice-template.page";

// component
import ProtectedRoute from "./routes/ProtectedRoute";
import VerificationRoute from "./routes/VerificationRoute";

// billing portal
import PortalRedirect from "./pages/bill-portal/bill-portal.page";
import ErrorFixer from "./pages/error-fixer/error-fix.page";
import InternalError from "./pages/error/internal-error.page";
import { useActiveExternalApp } from "./queries/company.queries";
// import InvoicePage from "./components/thermal-invoice";

const router = createBrowserRouter([{ path: "*", Component: Root }]);

function App() {
	return (
		<>
			{window.innerWidth > 680 ? (
				<div className="App">
					<RouterProvider router={router} />
					<ToastContainer
						position="top-right"
						autoClose={5000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable={false}
						pauseOnHover
					/>
				</div>
			) : (
				<div className="App-no-mobile-view">
					<img src={BillMeLogo} alt="BillMe by Nibjar" />
					Mobile view is not supported!
				</div>
			)}
		</>
	);
}

// company/application/list requires an authenticated session, so this must
// only mount once ProtectedRoute has confirmed one — not from Root, which
// renders before route matching and would fire the request (and a 403) on
// public routes like /login too.
function CreateInvoiceRoute() {
	const { billModel } = useActiveExternalApp();
	const isBillCreationBlocked = billModel === "A";

	return isBillCreationBlocked ? <Navigate to="/" replace /> : <CreateInvoice />;
}

function Root() {
	return (
		<Routes>
			<Route
				path="/login"
				element={<Login />}
				errorElement={<ErrorPage />}
			/>
			{/* BE's password-reset email links here (see
			billing_system_BE middleware/sendGridEmailHelper.js) — same
			Login component, which reads the ?token= param to switch into
			reset mode regardless of which of these two paths it's on. */}
			<Route
				path="/reset-password"
				element={<Login />}
				errorElement={<ErrorPage />}
			/>
			{/* billing portal */}
			<Route path="/portal" element={<PortalRedirect />} />
			{/* billing portal */}

			<Route element={<VerificationRoute />}>
				<Route
					path="/verification"
					element={<Verification />}
					errorElement={<ErrorPage />}
				/>
			</Route>
			<Route element={<ProtectedRoute />}>
				<Route
					path="/"
					element={<Dashboard />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/invoice/create"
					element={<CreateInvoiceRoute />}
					errorElement={<ErrorPage />}
				/>

				<Route
					path="/invoice/bills"
					element={<InvoiceBill />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/activities"
					element={<ActivityMonitor />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/customers"
					element={<CustomerList />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/employees"
					element={<EmployeeList />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/company-setting"
					element={<CompanySetting />}
					errorElement={<ErrorPage />}
				/>
				<Route
					path="/error-fix"
					element={<ErrorFixer />}
					errorElement={<ErrorPage />}
				/>
			</Route>

			<Route path="*" element={<MissingRoute />} />

			<Route
				path="/error"
				element={<InternalError />}
				errorElement={<ErrorPage />}
			/>

			{/* <Route
				path="/test"
				element={<InvoicePage />}
				errorElement={<ErrorPage />}
			/> */}
		</Routes>
	);
}

export default App;
